import React, { useEffect, useState } from "react";

import LeaderboardRow from "./LeaderboardRow";
import { useBotbLeaderboardContext } from "../context";
import ChevronsRightIcon from "../../../shared-components/icons/ChevronsRightIcon";
import { TopSubscribe } from "./TopSubscribe";
import { DEVICE_RESOLUTION } from "../../../app-constants";
import { getCookie } from "../../../../helpers/cookies";
import { SmarticoTournamentPlayer } from "../../../interfaces/smartico";
import { cn } from "@/lib/utils";

const MAX_CRITERIA = 15;

export function LeaderboardTable() {
  const { leaderboardPlayers, getPrize, youPlayer, tournamentFinished } = useBotbLeaderboardContext();
  const isAuth = getCookie("BotB.Authenticated") === "true";
  const [isMobile, setIsMobile] = useState(
    window.innerWidth >= DEVICE_RESOLUTION.MobileMin && window.innerWidth < DEVICE_RESOLUTION.Laptop
  );

  const playerYouPrize = getPrize(youPlayer);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth >= DEVICE_RESOLUTION.MobileMin && window.innerWidth < DEVICE_RESOLUTION.Laptop);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const fakeItem = (position: number): SmarticoTournamentPlayer => ({
    position: position + 5,
    public_username: `Alex****${position + 1}`,
    scores: 0,
    avatar_url: "",
    is_me: false,
    user_ext_id: "",
    crm_brand_id: 0,
    user_id: 0,
  });

  return (
    <div
      className={cn(
        `max-lg:max-w-screen-sm w-full max-lg:mx-auto mx-auto rounded-lg px-3 lg:px-6 py-6 lg:py-8 font-jost lg:bg-white lg:rounded-2xl ${tournamentFinished ? "lg:w-auto lg:max-w-[600px]" : ""}`
      )}>
      {isMobile && <TopSubscribe />}

      {/*<div className={"w-full lg:w-[50%] h-px bg-black/8 mt-2 mb-4 lg:my-5"}/>*/}

      {youPlayer && (
        <div className="flex flex-row justify-between mb-6">
          <div className="flex flex-col gap-1 text-left">
            {youPlayer?.position ? (
              <div className={"text-secondary text-base font-normal leading-5.5"}>Your Position</div>
            ) : null}
            <div className={"text-dark-1 text-base font-bold leading-5.5 lg:text-2xl lg:leading-[30px]"}>
              {youPlayer?.position}
            </div>
          </div>
          <div className="flex flex-col gap-1 text-center">
            {youPlayer?.scores ? (
              <div className={"text-secondary text-base font-normal leading-5.5"}>Points</div>
            ) : null}
            <div className={"text-dark-1 text-base font-bold leading-5.5 lg:text-2xl lg:leading-[30px]"}>
              {youPlayer?.scores}
            </div>
          </div>
          <div className="flex flex-col gap-1 text-right max-w-[32%]">
            {playerYouPrize ? (
              <div className={"text-secondary text-base font-normal leading-5.5"}>Potential Prize</div>
            ) : null}
            <div className={"text-dark-1 text-base font-bold leading-5.5 lg:text-2xl lg:leading-[30px]"}>
              {playerYouPrize?.name}
            </div>
          </div>
        </div>
      )}

      {/*<div className={"flex-center cursor-pointer mb-3 lg:mb-6"}>*/}
      {/*  <svg*/}
      {/*    xmlns="http://www.w3.org/2000/svg"*/}
      {/*    width="20"*/}
      {/*    height="20"*/}
      {/*    viewBox="0 0 20 20"*/}
      {/*    fill="none"*/}
      {/*    className={"size-5"}*/}
      {/*  >*/}
      {/*    <path*/}
      {/*      d="M8.33333 10C8.33333 10.442 8.50893 10.866 8.82149 11.1785C9.13405 11.4911 9.55797 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.866 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333C9.55797 8.33333 9.13405 8.50893 8.82149 8.82149C8.50893 9.13405 8.33333 9.55797 8.33333 10Z"*/}
      {/*      stroke="#3772FF"*/}
      {/*      stroke-width="1.5"*/}
      {/*      stroke-linecap="round"*/}
      {/*      stroke-linejoin="round"*/}
      {/*    />*/}
      {/*    <path*/}
      {/*      d="M17.5 10C15.5 13.3333 13 15 10 15C7 15 4.5 13.3333 2.5 10C4.5 6.66667 7 5 10 5C13 5 15.5 6.66667 17.5 10Z"*/}
      {/*      stroke="#3772FF"*/}
      {/*      stroke-width="1.5"*/}
      {/*      stroke-linecap="round"*/}
      {/*      stroke-linejoin="round"*/}
      {/*    />*/}
      {/*  </svg>*/}
      {/*  <span className={"text-nav-azure text-[13px] leading-4.5 font-medium"}>*/}
      {/*    Show my position in leaderboard*/}
      {/*  </span>*/}
      {/*</div>*/}

      {/* Leaderboard Table */}
      <div className="bg-white max-w-2xl mx-auto">
        <div className="bg-[#ECF0F5] text-gray-1 text-center text-[11px] font-medium leading-[14px] lg:text-base lg:font-semibold lg:leading-[22px] uppercase px-3 py-1.5 grid grid-cols-4 items-center rounded lg:rounded-lg lg:px-8 lg:py-3">
          <span className="text-left">POSITION</span>
          <span className="text-center">USER</span>
          <span className="text-center">POINTS</span>
          <span className="text-center">PRIZE</span>
        </div>

        <div className={"relative"}>
          {!isAuth && leaderboardPlayers.length >= MAX_CRITERIA && !tournamentFinished
            ? leaderboardPlayers
                .slice(0, 3)
                .map((item, index) => <LeaderboardRow key={index} item={item} index={index} />)
            : leaderboardPlayers.map((item, index) => <LeaderboardRow key={index} item={item} index={index} />)}

          {/*not logged in overlay*/}
          {!isAuth && leaderboardPlayers.length >= MAX_CRITERIA && !tournamentFinished ? (
            <div className={"relative"}>
              {Array.from({ length: 6 }).map((_, index) => (
                <LeaderboardRow key={index} item={fakeItem(index)} index={index + 3} />
              ))}

              <div
                className={
                  "absolute inset-0 size-full px-2 py-4 bg-gradient-to-b from-gray-4/10 to-gray-4 backdrop-blur-sm flex-center flex-col"
                }>
                <div className={"mb-1"}>
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={"size-8 lg:size-12"}>
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M22.6665 28H9.33317C7.85984 28 6.6665 26.8067 6.6665 25.3333V14.6667C6.6665 13.1933 7.85984 12 9.33317 12H22.6665C24.1398 12 25.3332 13.1933 25.3332 14.6667V25.3333C25.3332 26.8067 24.1398 28 22.6665 28Z"
                      stroke="#FF8200"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M16.0002 22.7866V19.3333"
                      stroke="#FF8200"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M16.7071 17.6263C17.0976 18.0168 17.0976 18.65 16.7071 19.0405C16.3166 19.431 15.6834 19.431 15.2929 19.0405C14.9024 18.65 14.9024 18.0168 15.2929 17.6263C15.6834 17.2357 16.3166 17.2357 16.7071 17.6263"
                      stroke="#FF8200"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.6665 12V9.33333V9.33333C10.6665 6.388 13.0545 4 15.9998 4V4C18.9452 4 21.3332 6.388 21.3332 9.33333V9.33333V12"
                      stroke="#FF8200"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div
                  className={
                    "mb-1 text-center text-base text-dark-1 font-medium leading-5.5 lg:text-lg lg:leading-6 lg:font-semibold"
                  }>
                  Curious About the Other Prizes?
                </div>
                <div className={"mb-6 text-center text-sm leading-5 text-gray-1 lg:text-base lg:text-5.5"}>
                  Log in to see more details.
                </div>
                <div>
                  <button
                    onClick={() => (location.href = `/login?ReturnUrl=${encodeURIComponent(location.pathname)}`)}
                    title={"Cancel Subscription"}
                    className={`theme-btn theme-btn-primary-outline text-primary theme-btn-xs lg:theme-btn-lg uppercase min-w-[120px] lg:min-w-[172px] lg:font-semibold`}>
                    LOG IN
                    <ChevronsRightIcon variant={2} className={"size-4 lg:size-6 shrink-0"} />
                  </button>
                </div>
              </div>
            </div>
          ) : null}
          {!isAuth && leaderboardPlayers.length >= MAX_CRITERIA && !tournamentFinished
            ? leaderboardPlayers
                .slice(leaderboardPlayers.length - 3)
                .map((item, index) => <LeaderboardRow key={index} item={item} index={index} showTrophee={false} />)
            : null}
        </div>
      </div>
    </div>
  );
}
